"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var FreeShippingThreshold_1 = require("./FreeShippingThreshold");
var CartItems_1 = require("./CartItems");
var OrderSummary_1 = require("./OrderSummary");
var CartContext_1 = require("./CartContext");
var hooks_1 = require("preact/hooks");
var YouMayAlsoLikeWrapper_1 = require("./YouMayAlsoLikeWrapper");
var ReviewContainer = function () {
    var hasSubscription = (0, hooks_1.useContext)(CartContext_1.default).hasSubscription;
    return ((0, preact_1.h)("div", { class: "cart-section__review-container" },
        (0, preact_1.h)(FreeShippingThreshold_1.default, null),
        (0, preact_1.h)("h2", { class: "cart-section__review-header ".concat(hasSubscription ? 'spacing' : '') }, "Your Cart:"),
        (0, preact_1.h)(CartItems_1.default, null),
        (0, preact_1.h)(YouMayAlsoLikeWrapper_1.default, null),
        (0, preact_1.h)("div", { class: "cart-section__summary-container-divider" }),
        (0, preact_1.h)(OrderSummary_1.default, null)));
};
exports.default = ReviewContainer;
